import React from 'react';

import { Component } from "react";

import './prioridade-solicitacaotd.css'
import { SRText } from '../ScreenReaderText/ScreenReaderText';
import { Prioridades } from 'model/solicitacao/PrioridadeSolicitacao';

interface PrioridadeSolicitacaoProps {
  prioridade: number
}

export default class PrioridadeSolicitacaoTD extends Component<PrioridadeSolicitacaoProps> {
  render() {
    const prioridadesClassNames = {
      1: 'prioridade-solicitacao-normal',
      2: 'prioridade-solicitacao-alta',
      3: 'prioridade-solicitacao-imediata',
    } as any

    const prioridadeClassName = prioridadesClassNames[this.props.prioridade] ?? prioridadesClassNames[1]
  
    const classe = `prioridade-solicitacao ${prioridadeClassName}`;
    const prioridade = Prioridades.byId(this.props.prioridade)

    return (
      <td className={classe} title={prioridade.nome}>
        <SRText>{prioridade.nome}</SRText>
      </td>
    )
  }
}
